import { render } from "./Recent.vue?vue&type=template&id=7c0054ae&scoped=true&ts=true"
import script from "./Recent.vue?vue&type=script&lang=ts"
export * from "./Recent.vue?vue&type=script&lang=ts"

import "./Recent.vue?vue&type=style&index=0&id=7c0054ae&scoped=true&lang=css"

import exportComponent from "/var/www/mj-root/fe-site-manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c0054ae"]])

export default __exports__